import './App.css';
import { Provider } from 'react-redux';
import { store } from './app/store';
import AppRouter from './components/router';
import './i18n';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { GoogleOAuthProvider } from '@react-oauth/google';


function App() {
  return (
    <Provider store={store}>
      <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID || ''}>
        <AppRouter />
        <ToastContainer autoClose={2000} />
      </GoogleOAuthProvider>
    </Provider>
  );
}

export default App;
